import { updateState } from '@/store/extensions/update';
import { fetchState } from '@/store/extensions/fetch';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...updateState,
  ...fetchState,

  reverting: false,
  context: null,
  diffModalOpened: false,
  diffModalAdditionalContext: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/version/index.js